import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger } from "@Common/helpers/logger";

export async function exportCitActivities({ locationId, commissionCycleId, payPeriodId, input }) {
	const query = gql`
		mutation exportCitActivities(
			$locationId: String!
			$commissionCycleId: String!
			$payPeriodId: String!
			$input: ExportCitActivitiesInput!
		) {
			exportCitActivities(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, input: $input) {
				locationId
				commissionCycleId
				payPeriodId
				urlDetails {
					presignedUrl
					fileName
					error {
						message
						status
					}
				}
				journalDetails {
					message
					success
				}
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
		input,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.exportCitActivities ?? null;
	} catch (err) {
		errorLogger(err, { function: "exportCitActivities", message: "Failed to export CIT Activities", variables });
		return null;
	}
}
